import { ApolloProvider } from "@apollo/client";
import createClient from "./client";

const ApolloQueryProvider = ({ children }) => {
  return <ApolloProvider client={createClient()}>{children}</ApolloProvider>;
};

export { ApolloQueryProvider };
